// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"539":"72e5d9c3","645":"72e5d9c3","853":"72e5d9c3","980":"72e5d9c3"}[chunkId] + ".chunk.css";
};